import { mdiAccountGroup } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import { isSubscriptionRestricted } from "../../../../_shared/_logic/access"

/** Members and invitations need membership read access; the roles tab additionally role reads. */
export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "users",
  title: "Benutzer",
  tooltip:
    "Mitarbeiter einladen, Benutzerkonten verwalten und Rollen sowie Zugriffsrechte festlegen.",
  icon: mdiAccountGroup,
  routeSegment: "users",
  getPages: (context) =>
    !isSubscriptionRestricted(context) && context.permissions.allows("core.memberships", "view")
      ? [
          {
            id: "users",
            title: "Benutzer",
            path: "",
            tabs: [
              {
                id: "members",
                title: "Benutzer",
                routeSegment: "members",
                testId: "controlAdmin.organizationView.tab.users",
              },
              ...(context.permissions.allows("core.roles", "view")
                ? [
                    {
                      id: "roles",
                      title: "Rollen",
                      routeSegment: "roles",
                      testId: "controlAdmin.organizationView.tab.roles",
                    },
                  ]
                : []),
            ],
          },
        ]
      : [],
}
